import { render, staticRenderFns } from "./CourseCategoryForm.vue?vue&type=template&id=8728e084"
import script from "./CourseCategoryForm.vue?vue&type=script&lang=js"
export * from "./CourseCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports